export const nav = 1;

export default {
  ["customer-merge"]: {
    nav,
    icon: "object-group",
    url: "/customer-merge",
    title: "Merge Customers",
    templateProvider: $stateParams => `<customer-merge />`
  },
};
